/*
Based on API documentation here: https://developers.stamped.io/#7d02c323-794e-443f-9512-28373a244854
*/

if (!customElements.get('pdp-stamped-reviews')) {
	customElements.define(
		'pdp-stamped-reviews',
		class PDPStampedReviews extends HTMLElement {
			constructor() {
				super();
				this.appliedFilters = [''];
				this.productId = null;
				this.publicKey = `6014581e-be2a-4edf-9d1e-ac23c4a7100f`;
				this.storeUrl = `getmtnops.myshopify.com`;
			}

			connectedCallback() {
				document.addEventListener('DOMContentLoaded', () => {
					this.productId = this.dataset.productId;
					this.tags = this.dataset.tags?.replace(/ /g, '').split(',');
					this.getReviews();
				});
			}

			async getReviews() {
				await fetch(
					`https://stamped.io/api/widget/reviews?minRating=1&productId=${this.productId}&take=100&storeUrl=${this.storeUrl}&apiKey=${this.publicKey}`
				)
					.then((response) => response.json())
					.then((json) => {
						if (!json.data.length) {
							return;
						}

						this.innerHTML = '';
						this.generateSliderMarkup(json);
					})
					.catch((err) => {
						console.error(`Unable to load the custom Stamped widget.`, err);
					});
			}

      generateSliderMarkup(reviews) {
        const rating = Number(reviews.rating) || 0;
        const totalReviews = Number(reviews.total) || 0;
        const clamped = Math.max(0, Math.min(5, rating));
        const fullStars = Math.floor(clamped);
        const decimal = clamped - fullStars;

        let halfStars = 0;
        let filledStars = fullStars;

        if (decimal >= 0.25 && decimal < 0.6) {
          halfStars = 1;
        } else if (decimal >= 0.6) {
          filledStars = Math.min(fullStars + 1, 5);
        }

        const emptyStars = 5 - filledStars - halfStars;

        const starsHTML = [
          ...Array.from({ length: filledStars }, () =>
            `<i class="stamped-fa stamped-fa-star" aria-hidden="true"></i>`
          ),
          ...Array.from({ length: halfStars }, () =>
            `<i class="stamped-fa stamped-fa-star-half-o" aria-hidden="true"></i>`
          ),
          ...Array.from({ length: emptyStars }, () =>
            `<i class="stamped-fa stamped-fa-star-o" aria-hidden="true"></i>`
          )
        ].join('');

        const reviewLabel = totalReviews === 1 ? '1 review' : `${totalReviews} reviews`;

        this.innerHTML = `
          <span class="stamped-badge" data-rating="${rating}">
            <span class="stamped-starrating stamped-badge-starrating" aria-hidden="true">
              ${starsHTML}
            </span>
            <span
              class="stamped-badge-caption"
              data-reviews="${totalReviews}"
              data-rating="${rating}"
              data-label="reviews"
              aria-label="${reviewLabel}"
              data-version="2"
            >${reviewLabel}</span>
          </span>
        `;
      }
		}
	);
}
